export const membershipTypes = {
  annualyMembership: "annualy",
  monthlyMembership: "monthly",
  ultimateMembership: "ultimate",
  freeTrial: "freeTrial",
  canceledSubscription: "canceledSubscription",
  noMembership: "none",
};

export const subscriptionStatusTypes = {
  active: "active",
  canceled: "canceled",
  expired: "expired",
  extended: "extended",
  noSubscription: "noSubscription",
};

export const responseMessages = {
  requestRegistered: "requestRegistered",
};

export const errorMessages = {
  alreadySubscribed: "alreadySubscribed",
  userNotFound: "userNotFound",
  passwordAlreadyConfirmed: "passwordAlreadyConfirmed",
  validationError: "validation error",
  JsonWebTokenError: "JsonWebTokenError",
  TokenExpiredError: "TokenExpiredError",
  invalidCredentials: "invalidCredentials",
  noSuchDiscount: "noSuchDiscount",
  couponNotForThisProduct: "couponNotForThisProduct",
  noActiveSubscription: "noActiveSubscription",
  userAlreadyRegistered: "userAlreadyRegistered",
  invalidEmailFormat: "invalidEmailFormat",
};
